<template>
  <!-- tw-h-8 gives the bar the 32px height of SfButtonDs. .sf-btn-bar is an
       inline-flex container, so its items stretch to that height and the
       control passed through <slot> is as tall as the chevron links. The links
       carry no vertical padding; flex centring places the chevron icon. -->
  <div class="sf-level-item sf-btn-bar sf-btn-bar--no-clip tw-h-8">
    <slot></slot>
    <a
      href="#"
      class="sf-btn sf-btn-bar-item tw-flex tw-items-center !tw-py-0"
      data-testid="carousel-prev"
      @click.prevent.stop="handlePrevClick"
    >
      <i class="fa fa-chevron-left" />
    </a>
    <a
      href="#"
      class="sf-btn sf-btn-bar-item tw-flex tw-items-center !tw-py-0"
      data-testid="carousel-next"
      @click.prevent.stop="handleNextClick"
    >
      <i class="fa fa-chevron-right" />
    </a>
  </div>
</template>

<script setup lang="ts">
interface Props {
  previousAction: string
  nextAction: string
}

const props = defineProps<Props>()

function handlePrevClick() {
  window.Turbolinks.visit(props.previousAction)
}

function handleNextClick() {
  window.Turbolinks.visit(props.nextAction)
}
</script>
